<template>
    <div class="topmenu" :class="setClass">
        <div class="logo">
            <template v-if="showAnonymousMenu">
                <img src="/images/logo.svg" alt="Simply Logo" />
            </template>
            <template v-else>
                <router-link :to="setLogoLink">
                    <img src="/images/logo.svg" alt="Simply Logo" />
                </router-link>
            </template>
        </div>
        <menu v-if="showMainMenu">
            <router-link to="/projects/active">Overview</router-link>
            <router-link to="/account">Account</router-link>
            <span v-if="showAdminMemberMenu">
                <router-link to="/member/list">Users</router-link>
                
            </span>          
            <span v-if="isSuperAdmin">
                <router-link to="/settings/list">Settings</router-link>
            </span>
            <a href="/api/member/logout">Sign out</a>
        </menu>
        <div v-if="showDataViewMenu" class="breadcrump">
            {{$store.state.dataView.forecast.projectTitle}}<span style="padding-left:5px;padding-right:5px;">></span>
            {{$store.state.dataView.forecast.programTitle}}<span style="padding-left:5px;padding-right:5px;">></span>
            {{$store.state.dataView.forecast.title}}
        </div>
        <menu v-if="showDataViewMenu">
            <router-link v-if="$store.state.dataView.forecast.viewUrl" :to="$store.state.dataView.forecast.viewUrl">Simulation</router-link>
            <router-link v-if="$store.state.dataView.forecast.dataUrl" :to="$store.state.dataView.forecast.dataUrl">Data</router-link>
            <a v-if="showAnonymousMenu" href="/api/member/logout">Sign out</a>
        </menu>        
    </div>
</template>

<script>
    export default {
        props: {
            pageName: {
                type: String,
                required: false
            }
        },
        computed: {
            setLogoLink() {
                if(this.$route.name === "login" || this.$route.name === "forgot-password")
                    return "/login";

                return "/projects/active";
            },
            setClass() {
                if(this.$route.name === "login" || this.$route.name === "forgot-password")
                    return "transparent";

                if(this.$route.name.indexOf("studyEditor") !== -1 || this.$route.name.indexOf("studyAggregator") !== -1)
                    return "sided";
            },
            showMainMenu() {
                if(this.$route.name === "login" || this.$route.name === "forgot-password" || this.$route.name === "dataView")
                    return false;

                return true;
            },
            showDataViewMenu() {                
                if(this.$route.name !== "dataView" || !this.$store.state.dataView.isLoaded || !this.$store.state.dataView.forecast)
                    return false;

                return true;
            },
            showAnonymousMenu(){
                return this.$store.state.member.isAnonymous;
            },
            showAdminMemberMenu() {                
                return this.$store.state.member.isAdmin || this.$store.state.member.isSuperAdmin;
            },
            isSuperAdmin() {
                return this.$store.state.member.isSuperAdmin;
            }
        }
    }
</script>
